var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import FlightSearchContants from "../models/FlightSearchConstants.js";
const getDefaultState = () => {
  return {
    searchResults: [],
    searchError: false,
    fetchState: "NotStarted",
    filter: {
      managementGroup: "",
      dateRange: {
        from: null,
        to: null
      },
      query: null
    },
    flightSearchContext: {
      workspaceId: "",
      managementgroup: "",
      owner: "",
      startedafter: "",
      startedbefore: "",
      q: ""
    }
  };
};
const FlightSearchReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case FlightSearchContants.SET_FLIGHT_SEARCH_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        flightSearchContext: actionResult.payload
      });
    case FlightSearchContants.FETCH_FLIGHT_RESULTS:
      let result = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        fetchState: "Fetching",
        searchError: false,
        searchResults: null,
        filter: {
          managementGroup: result.managementGroup,
          query: result.searchQuery,
          dateRange: {
            from: result.fromDate,
            to: result.toDate
          }
        }
      });
    case FlightSearchContants.FETCH_FLIGHT_RESULTS_COMPLETE:
      let resultnew = actionResult;
      return __spreadProps(__spreadValues({}, state), {
        fetchState: "Completed",
        searchError: resultnew.error,
        searchResults: resultnew.payload
      });
    default:
      return state;
  }
};
export {
  FlightSearchReducer,
  FlightSearchReducer as default,
  getDefaultState
};
//# sourceMappingURL=FlightSearchReducer.js.map
